import React from "react"

const AnchorBlock = ({ block }) => {
  return (
    <section className="anchor-block">
      <div className="anchor-block-wrapper">
        <div className="anchor-block-container">
          <div className="anchor-block-anchor" id={block.target_hash}></div>
        </div>
      </div>
    </section>
  )
}

export default AnchorBlock
